import axios from 'axios'

class AuthApi {
  init = baseURL => {
    this.authApi = axios.create({ baseURL })
  }

  login = body => {
    return this.authApi.post('/auth', body)
  }

  signup = body => {
    return this.authApi.post('/users', body)
  }

  updateUser = (body, token) => {
    return this.authApi.put('/users/me', body, { headers: { Authorization: token } })
  }

  softVerify = body => {
    return this.authApi.post('/unverified-users', body)
  }

  forgotPassword = body => {
    return this.authApi.post('/auth/forgot-password', body)
  }

  resetPassword = body => {
    return this.authApi.post('/auth/reset-password', body)
  }

  screenEmail = body => {
    return this.authApi.get(`/auth/screenEmail?email=${body}`)
  }

  getJumioAuthToken = body => {
    return this.authApi.get(`/auth/jumioAuthToken`, body)
  }

  verifyEmail = body => {
    return this.authApi.post(`/auth/verify-email`, body)
  }

  sendVypeVerificationEmail = body => {
    return this.authApi.post(`/auth/send-vype-verification-email`, body)
  }

  me = token => {
    return this.authApi.get(`/users/me`, { headers: { Authorization: token } })
  }

  cancelSubscription = body => {
    return this.authApi.delete('/subscriptions', { headers: { Authorization: body.token } })
  }

  editSubscription = body => {
    return this.authApi.put('/subscriptions', body, { headers: { Authorization: body.token } })
  }

  addPaymentMethod = body => {
    return this.authApi.post('/payment-methods', body, { headers: { Authorization: body.token } })
  }

  deletePaymentMethod = body => {
    return this.authApi.delete(`/payment-methods/${body.id}`, { headers: { Authorization: body.token } })
  }

  cancelOrder = body => {
    return this.authApi.post('/orders/cancel', body, { headers: { authorization: body.token } })
  }

  getPriceBreakdown = ({ params, token }) => {
    return this.authApi.post('/checkout/price_breakdown', params, {
      headers: { authorization: token }
    })
  }

  setShippingMethods = ({ params, token }) => {
    return this.authApi.get('/checkout/shipping_methods', {
      params,
      headers: { Authorization: token }
    })
  }

  completeCheckout = ({ body, token }) => {
    return this.authApi.post('/checkout/complete', body, { headers: { Authorization: token } })
  }

  getCanadaPostOffices = body => {
    return this.authApi.post('/canadapost/offices', body)
  }

  getOrder = ({ orderId, token }) => {
    return this.authApi.get(`/orders/${orderId}`, {
      headers: { authorization: token }
    })
  }

  submitCalloutApplication = ({ data, token }) => {
    return this.authApi.post('/callout_applications', data, {
      headers: { authorization: token }
    })
  }

  getRetailers = body => {
    return this.authApi.post('/retailers', body)
  }

  getProducts = () => {
    return this.authApi.get('/products')
  }

  createBoostPlanOrder = ({ data, token }) => {
    return this.authApi.post(`${process.env.GATSBY_AUTH_API}/orders/boost-plan`, data, {
      headers: { Authorization: token }
    })
  }

  claimTransitionEpod = (data, token) => {
    return this.authApi.post(`${process.env.GATSBY_AUTH_API}/orders/claim-transition-epod`, data, {
      headers: { Authorization: token }
    })
  }

  validateEmail = ({ email }) => {
    return this.authApi.get(`${process.env.GATSBY_AUTH_API}/users/email-exists/${email}`)
  }

  submitCalloutVotes = (data, token) => {
    return this.authApi.post(`${process.env.GATSBY_AUTH_API}/callout_vote_options`, data, {
      headers: { Authorization: token }
    })
  }

  getSubscriptionPriceBreakdown = ({ body, token }) => {
    return this.authApi.post(`${process.env.GATSBY_AUTH_API}/subscriptions/price-breakdown`, body, {
      headers: { Authorization: token }
    })
  }
}

export default new AuthApi()
